import { useMemo } from "react";
import { Badge } from "@radix-ui/themes";
import { fixToTwo } from "@/v2/components/formatters/NumberFormatter";
import { RadixColor } from "@/components/radixColors";

type ScaleValue = "positive" | "negative" | "neutral";

const scaleToColor: Record<ScaleValue, RadixColor> = {
  positive: "green",
  negative: "red",
  neutral: "gray",
};

interface ScaleFormatterProps {
  value: number;
  getScale: (value: number) => ScaleValue;
}

export function ScaleFormatter({ value, getScale }: ScaleFormatterProps) {
  const color = useMemo(() => {
    const scale = getScale(value);
    return scaleToColor[scale];
  }, [value, getScale]);

  return (
    <Badge color={color} variant="soft" size="1">
      <div className={`h-2 w-2 bg-current rounded-[2px]`} />
      <div className="font-mono tabular-nums text-left">
        {Math.round(Math.abs(value))}
      </div>
    </Badge>
  );
}
